// DEPLOYMENT STATUSES
export const BLOCKED = 'blocked';
export const CREATED = 'created';
export const MANUAL_DEPLOY = 'manual_deploy';
export const WILL_DEPLOY = 'will_deploy';
export const RUNNING = 'running';
export const SUCCESS = 'success';
export const FAILED = 'failed';
export const CANCELED = 'canceled';
export const SKIPPED = 'skipped';

// ACTION STATUSES
export const STOPPING = 'stopping';
export const DEPLOYING = 'deploying';
export const REDEPLOYING = 'redeploying';

export const ACT_BUTTON_ICONS = {
  play: 'play',
  repeat: 'repeat',
  stop: 'stop',
};
